import { GatsbySSR } from 'gatsby'

import ErrorBoundary from './src/components/ErrorBoundary'
import Layout from './src/components/layout'
import './static/fonts.css'

export const wrapPageElement: GatsbySSR['wrapPageElement'] = ({
  element,
  props,
}) => (
  <ErrorBoundary>
    <Layout {...props}>{element}</Layout>
  </ErrorBoundary>
)
